/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResult2,
  NotFoundErrorResult2,
  ResultOfListOfIntermediaryClientRelationshipViewModel,
  ValidationErrorResult2,
} from '../models';
import {
    ErrorResult2FromJSON,
    ErrorResult2ToJSON,
    NotFoundErrorResult2FromJSON,
    NotFoundErrorResult2ToJSON,
    ResultOfListOfIntermediaryClientRelationshipViewModelFromJSON,
    ResultOfListOfIntermediaryClientRelationshipViewModelToJSON,
    ValidationErrorResult2FromJSON,
    ValidationErrorResult2ToJSON,
} from '../models';

/**
 * 
 */
export class ReportingApi extends runtime.BaseAPI {

    /**
     * Get Proposal and client
     */
    async reportingGetClientPlansRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfListOfIntermediaryClientRelationshipViewModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v1/reporting/plans`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfListOfIntermediaryClientRelationshipViewModelFromJSON(jsonValue));
    }

    /**
     * Get Proposal and client
     */
    async reportingGetClientPlans(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfListOfIntermediaryClientRelationshipViewModel> {
        const response = await this.reportingGetClientPlansRaw(initOverrides);
        return await response.value();
    }

}
